import { withExperienceNotifier } from 'view/common/analytics';
import RequestCreateForm from './request-create-form';

export default withExperienceNotifier('request-create-form')(RequestCreateForm);
